<template>
<v-btn color="primary" :to="{name: 'Home', params:{place: title}}">{{ label }}</v-btn>
</template>
<script>
export default {
  props: ['title','label', 'url'],
  data: () => ({
  })
}
</script>
